import React from 'react';
import { Icons } from '../../../../components/atoms/SVG';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views as BlockInteractionsViews,
} from '../../../../components/organisms/BlockInteractions';
import { Namespace } from '../../../../translation/namespace';
import { ExternalContentEditView } from '../views/ExternalContentEditView';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../../../types/BlockWithViews';
import { ExternalContentEditDefaultView } from '../views/ExternalContentEditDefaultView';
import { useBlockContext, useRefreshBlock } from '../../../BlockFetcher';
import { useContentWrapperContext } from '../../../../components/blocks/ContentWrapper/ContentWrapperContext';
import { ExternalContentDefaultViewProps } from '../views/ExternalContentDefaultView';
import { useContentWrapperDndContext } from '../../../../components/blocks/ContentWrapper/ContentWrapperDndProvider';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { headlineHierarchy } from '../../../../components/organisms/BlockInteractions/BlockInteractions.utils';

export type ExternalContentBlockProps = Views<
  DefaultView<ExternalContentDefaultViewProps> & OptionalEditView<ExternalContentEditView> & DeleteAction
>;

export function ExternalContentInteractions({ views, activeView = 'default' }: ExternalContentBlockProps) {
  const { t } = useSonTranslation('ExternalContent');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();
  const contentWrapperContext = useContentWrapperContext();
  const contentWrapperDndContext = useContentWrapperDndContext();

  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `${Namespace.ExternalContent}:edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <ExternalContentEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(
        BlockInteractionsViews.DELETE,
        Icons.ERASER,
        'ExternalContent:delete',
        DISPLAY_TYPE.MODAL,
        null,
      )),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{
        text: t('headline'),
        hierarchy: headlineHierarchy(2, contentWrapperContext?.parentIndex, contentWrapperContext?.grandParentIndex),
        visible: true,
      }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      contentWrapperContext={contentWrapperContext}
      contentWrapperDndContext={contentWrapperDndContext}
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <ExternalContentEditDefaultView {...views.default} />
    </BlockInteractions>
  );
}
